import React from "react";
import Popup from "reactjs-popup";
import VideoPlayer from "../videos/VideoPlayer";
import { Link } from "react-router-dom";
import ClassStatus from "./classStatus";

import video_icon from "../images/video_icon.png";
import trophy_image from "../images/Trophy.png";
import "./classResult.css";
import play from "../images/play19.png";

export default function ClassResult(props) {
  let is_stripped_table = props.class_details.has_splits
    ? ""
    : " table-striped";
  if(props.class_details.is_team_event) is_stripped_table = ""; // not striped for team scoring table

  const trips = props.trips.length;

  function getVideosList(uuid) {
    var trip = props.videos_list.find((v) => v.uuid == uuid);
    if (trip) {
      var videos = trip.videos;
      return videos;
    }
    return [];
  }

  function getVideosListDivision(class_id, uuid) {
    var class_trips = props.videos_list.find((v) => v.class_id == class_id);
    if (class_trips) {
      var trip = class_trips.videos.find((v) => v.uuid == uuid);
      if (trip) {
        var videos = trip.videos;
        return videos;
      }
    }
    return [];
  }

  function getFaultTime(
    time_faults,
    faults,
    time,
    round_no,
    placing,
    is_result,
    getTimeFaultOnly = false,
    getObsFaultOnly = false
  ) {
    var JOQualified = false;

    if (props.jumper_table_info && props.jumper_table_info.hasJO) {
      if (time_faults) {
        JOQualified = false;
      } else {
        JOQualified = true;
      }
    }

    var hasPlacing = placing > 0 && placing != 100000;
    var hasJOScore = hasPlacing && JOQualified;

    var total_faults = time_faults + faults;
    if (time > 0) {
      if(getTimeFaultOnly){
        return time_faults;
      }
      else if(getObsFaultOnly){
        return faults;
      }

      var time_string = time.toString();
      if (props.jumper_table_info && props.jumper_table_info.fei_rule) {
        time = time_string.slice(0, time_string.indexOf(".") + 3);
      } else {
        time = time_string.slice(0, time_string.indexOf(".") + 4);
      }
      return total_faults + " | " + time;
    } else if (is_result) {
      if ((round_no == 1 && hasPlacing) || (round_no == 2 && hasJOScore)) {
        return "-";
      } else {
        return " - ";
      }
    } else {
      return " - ";
    }
  }
  
  function getTeamImagePath(TAbbr, TType, is_thumbnail) {
    var path = "";
    if (TType == "") {
      return path;
    }

    path = "http://cdn.showgroundslive.com/Team_Scoring_Logos/";

    //Check team type
    if (TType == "Country") {
      path += "Countries";
    } else {
      path += "Organizations";
    }

    //Check image type to return
    if (is_thumbnail) {
      path += "/Thumbnails";
    } else {
      path += "/Large";
    }

    path += "/" + TAbbr + ".png";

    return path;
  }

  let bgColor="bg-light";
  let bgColorMobileAlter = false;

  if(!props.class_details.is_team_event){ //Retain old sort for non team events
    props.result_trips.sort((a, b) => (a.place === 0) - (b.place === 0) || a.place - b.place)
  }

  return (
    <div>
      {(props.related_data.class_split_codes.length > 1 && !props.class_details.is_team_event) && (
        <div className='section-tab'>
          {props.related_data.class_split_codes.map((code, index) => {
            const default_section =
              props.related_data.current_split_code === code ? " active" : "";
            return (
              <button
                key={index}
                className={["sectionLink", default_section].join(" ")}
                onClick={props.openSection(code)}
                id={code}>
                Section {code}
              </button>
            );
          })}
        </div>
      )}
      <ClassStatus
        id='Result'
        class_details={props.class_details}
        related_data={props.related_data}
        trips={trips}
        callby={props.callby}
      />
      {props.class_details.is_team_event &&
      <div className="mobile-responsive is_team_event" id="is_team_event">
        <table className="table team-results table-responsive ">
          <tbody>
            {
              props.result_trips.map((data,index)=>{
                let prev_trip = index > 0 ? props.result_trips[index-1] : { team_id: -9999 };
                let newTeamRow = prev_trip?.team_id != data?.team_id;
                if(!data?.is_team_trip) { bgColorMobileAlter = !bgColorMobileAlter; } //for alternating colors of independent trips, striped effect

                return (
                <>
                {(data?.is_team_trip && newTeamRow) &&
                (
                <>
                {/* <tr class="header-spacer"></tr> */}
                <tr className="mobile-team-header ">
                 <th className="primary-header sgl-primary-header mobile-primary-team-header"  >
                    {
                      data.placing <= 10000 &&
                        <div className="mobile-placing">
                        <div><h2 className= {"mobile-placing-text " +"place_" +data.placing}
                          dangerouslySetInnerHTML={{
                            __html:data.team_rank_placing
                          }}
                        ></h2></div>
                        </div>
                    }
                    <div className="mobile-team-flag-container">
                      <img
                        src={getTeamImagePath(data.team_abbr, data.team_type, false)}
                        className="mobile-team-flag"
                        alt=''
                        onError={(e)=>{e.target.parentNode.style.display = "none";} } 
                      />
                    </div>

                    <div className="mobile-scores-team" >
                      <div className="mobile-team-name-div">
                        <h3 className="mobile-team-text">{data.team_name ? data.team_name?.toUpperCase() : <br/>}</h3>
                      </div>
                      <div className="mobile-scores" >
                        {(data?.team_score_one < 200 && props.class_details.class_type == "Jumpers") &&
                        <div className="mobile-round-one">
                          <label className="team-scoring-label">Round 1:</label>&nbsp;{data.team_score_one}
                        </div>
                        }
                        {(props.class_details.has_r2 && data?.has_r2 && data?.team_score_two < 200 && props.class_details.class_type == "Jumpers") &&
                          <div className="mobile-round-two">
                            <label className="team-scoring-label">Round 2:&nbsp;</label> {data.team_score_two}
                          </div>
                        }
                        {(props.class_details.class_type != "Jumpers") &&
                        <div className="mobile-round-one">
                          &nbsp;
                        </div>
                        }
                        {(data?.team_total_score < 200 || props.class_details.class_type != "Jumpers") &&
                        <div className="mobile-total-score">
                          <label className="team-scoring-label">Score:&nbsp;</label>  {data.team_total_score}
                        </div>
                        }
                      </div>
                    </div>
                  </th>
                </tr>
                </>
                )}
                <tr className={"mobile-entry-row"+ ((!data?.is_team_trip && bgColorMobileAlter)?" bg-dark":" bg-light")} >
                  <td>
                    <div className="mobile-entry-div-container" >
                    {!data?.is_team_trip &&
                      <div className="mobile-placing">
                        <div>
                          <h2 className= {"mobile-placing-text " +"place_" +data.placing}
                            dangerouslySetInnerHTML={{
                              __html: (data.placing > 0 && data.placing != 100000) ? ( data.rank_placing ) : ("&nbsp;&nbsp;&nbsp;")
                            }}
                          ></h2>
                        </div>
                      </div>
                    }
                    <div className="entry-data">
                      <div className="entry">
                      <Link
                          to={
                            "/entries/detail?eid=" +
                            data.entry_id +
                            "&sid=" +
                            props.current_show
                          }>
                          {data.number} - {data.horse}
                        </Link>
                      </div>
                      <div className="rider">
                      <Link
                          to={
                            "/people/detail?pid=" +
                            data.rider_id +
                            "&sid=" +
                            props.current_show
                          }>
                        {data.rider_name}
                        </Link>
                      </div>

                      {
                      ( props.class_details.class_type == "Jumpers" ) &&
                      <div  className="trip-scores">
                        {
                        (data.disqualify_status_one || data.time_fault_one > 0 || data.faults_one > 0 || data.time_one > 0) &&
                        <>
                        <div className="trip-fault-one">
                          <label className="trip-scoring-label" style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>R1F:&nbsp;</label>
                          <div style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>
                              {data.disqualify_status_one != ""
                                ? data.disqualify_status_one
                                : getFaultTime(
                                  data.time_fault_one,
                                  data.faults_one,
                                  data.time_one,
                                  1,
                                  data.placing,
                                  true
                                )?.split(" | ")?.[0]} {/** split to remove time from the returned value */}
                            </div>
                        </div>
                        <div className="trip-time-one" style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>
                          <label className="trip-scoring-label"  style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>R1T:&nbsp;</label>
                          {data.time_one}
                        </div>
                        </>
                        }
                        {
                          (props.class_details?.has_r2 && data?.has_r2) &&
                          <>
                          <div className="trip-fault-two">
                          <label className="trip-scoring-label"  style={data?.is_drop_trip_r2 ? {color:"red"}: {} }>R2F:&nbsp;</label>
                            <div style={data?.is_drop_trip_r2 ? {color:"red"}: {} } >
                            {data.disqualify_status_two != ""
                              ? data.disqualify_status_two
                              : getFaultTime(
                                data.time_fault_two,
                                data.faults_two,
                                data.time_two,
                                2,
                                data.placing,
                                true
                              )?.split(" | ")?.[0]} {/** split to remove time from the returned value */}
                          </div>
                          </div>
                          <div className="trip-time-two" style={data?.is_drop_trip_r2 ? {color:"red"}: {} }>
                              <label className="trip-scoring-label"   style={data?.is_drop_trip_r2 ? {color:"red"}: {} }>R2T:&nbsp;</label>
                              {data.time_two}
                          </div>
                          </>
                        }
                      </div>
                      }
                      {
                      (props.class_details.class_type == "Hunters" ||
                      props.class_details.class_type == "Equitation") &&
                      <div  className="trip-scores">
                      {
                      props.related_data.score_fields.map((f, index) => {
                        return (
                          <div>
                            <label className="trip-scoring-label" style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>S{f}&nbsp;</label>
                            <div style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>
                              {data["score" + f]}
                            </div>
                          </div>
                        );
                      })
                      }
                      {
                        <div>
                          <label className="trip-scoring-label" style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>Score&nbsp;</label>
                          <div style={data?.is_drop_trip_r1 ? {color:"red"}: {} }>
                          {data["score"]}
                          </div>
                        </div>
                      }
                      </div>
                      }
                    </div>
                    {props.related_data.is_videos_enabled == true && (
                      <div className="mobile-video-div">
                          {
                          getVideosList(data.entryxclasses_uuid).length > 0 ? (
                              <div>
                                <ul className='popup-ul'>
                                  {getVideosList(data.entryxclasses_uuid).map(
                                    (data, index) => {
                                      return (
                                        <img src={play} onClick={props.playVideo(data.sgl_id)} className='mobile-play-icon'/>
                                  )})}
                                </ul>
                              </div>
                          ) : (
                            ""
                          )
                          }
                      </div>)
                    }
                    </div>
                    {data?.is_team_trip && <hr className="mobile-teams-hr" />}
                  </td>
                  <hr  />
                </tr>
                </>
                )}
              )
            }
          </tbody>
        </table>
      </div>
      }
      <div className={['div-responsive', 'class-detail', props.class_details.is_team_event ? "is_team_event" : ""].join(" ")} id={ props.class_details.is_team_event ? "is_team_event" : ""}>
        {/*  is_stripped_table */}
        <table style={{borderCollapse:'collapse'}} className={["table",is_stripped_table,props.class_details.is_team_event ? "team-results" : ""].join(" ")}>
          <thead className='classes-header'>
          {( //props.class_details.class_type == "Jumpers" && 
                  <tr className='sgl-primary-header rounds-label-header'>
                     <th className='center-align' nowrap='nowrap'  style={{verticalAlign:"middle"}}  rowSpan={2}>
                        {props.class_details.is_team_event ? "Team" : "Rank" }
                      </th>
                      {props.related_data.is_videos_enabled == true && (
                        <th nowrap='nowrap'  style={{verticalAlign:"middle"}}  rowSpan={2}></th>
                      )}
                      <th nowrap='nowrap' style={{verticalAlign:"middle"}} rowSpan={2}>Horse</th>
                      <th nowrap='nowrap' style={{verticalAlign:"middle"}}  rowSpan={2}>Rider</th>

                      {props.related_data.has_prize_money && !props.class_details.is_team_event && (
                        <th nowrap='nowrap' style={{verticalAlign:"middle"}}  rowSpan={2}>Prize</th>
                      )}
                    {/* <th colSpan={props.related_data.has_prize_money && !props.class_details.is_team_event  ? 5 : 4}></th>   */}
                    {
                      props.class_details.class_type == "Jumpers" && 
                      <>
                      <th colSpan={props.class_details.is_team_event ? 4 : 3} className="center-align rounds-label" >Round 1<hr className="rounds-label-hr"/></th>
                      { (props.class_details.has_r2 || props.jumper_table_info.hasJO) &&
                        <th colSpan={props.class_details.is_team_event ? 4 : 3} className="center-align rounds-label">
                          { props.jumper_table_info?.roundLabels.r2.name ?? 'Round 2' }
                        <hr className="rounds-label-hr"/></th>
                      }

                        { props.jumper_table_info.hasR3Data &&
                            <th
                                colSpan={props.class_details.is_team_event ? 4 : 3}
                                className="center-align rounds-label"
                            >
                                { props.jumper_table_info?.roundLabels.r3.name ?? 'Round 3' }
                                <hr className="rounds-label-hr"/>
                            </th>
                        }
                    </>
                    }
                  </tr>
          )}
            <tr className='sgl-primary-header'>
              
              {
                props.class_details.class_type == "Jumpers" &&
                <>
                  <th>J</th>
                  <th>T</th>
                  <th>F&nbsp;|&nbsp;Time</th>
                  {
                    props.class_details.is_team_event &&
                    <th className="center-align">S</th>
                  }
                </>
              }

              {
                props.class_details.class_type == "Jumpers" && (props.class_details.has_r2 || props.jumper_table_info.hasJO) &&

                <>
                  <th>J</th>
                  <th>T</th>
                  <th>F&nbsp;|&nbsp;Time</th>
                  {
                    props.class_details.is_team_event &&
                    <>
                      <th className="center-align">S</th>
                    </>
                  }
                </>
              }

              { props.jumper_table_info.hasR3Data &&
                <>
                    <th>J</th>
                    <th>T</th>
                    <th>F&nbsp;|&nbsp;Time</th>
                    {
                        props.class_details.is_team_event &&
                        <>
                            <th className="center-align">S</th>
                        </>
                    }
                </>
              }

              {false && props.class_details.is_team_event ?
              <>
              </>
              :
              <>
              {(props.class_details.class_type == "Hunters" ||
                props.class_details.class_type == "Equitation") &&
                props.related_data.score_fields.map((f, index) => {
                  return (
                    <th key={index} className='center-align' nowrap='nowrap'>
                      S{f}
                    </th>
                  );
                })}
              {(props.class_details.class_type == "Hunters" ||
                props.class_details.class_type == "Equitation") && (
                  <th className='center-align' nowrap='nowrap'>
                    Score
                  </th>
                )}
              </>
              }
            </tr>
          </thead>
          <tbody>
            {props.result_trips
              .map((data, index) => {
                let prev_trip = index > 0 ? props.result_trips[index-1] : { team_id: -9999 };
                let newTeamRow = prev_trip?.team_id != data?.team_id;

                if(newTeamRow || !data?.is_team_trip){
                  //bgColor=bgColor=="bg-dark"?"bg-light":"bg-dark";  //bg color for team rows for striped table colors effect
                }
                let rowSpan = data?.team_trips; //rowspan for team dat
                const elder_row = newTeamRow ? "elder-row":""; //first row of each team for setting border colors

                const default_display =
                  !props.class_details.has_splits ||
                    props.related_data.current_split_code === data.split_section
                    ? " display_row"
                    : " display_none";
                return (
                  <tr
                    key={index}
                    className={props.class_details.is_team_event ? 
                      "team-rows " + elder_row + " "+bgColor:
                      [
                        "section",
                        default_display,
                        "split_" + data.split_section,
                        data.scratch_trip ? "strike_out" : "",
                        "sgl-anchor",
                      ].join(" ")
                    }
                    nowrap='nowrap'>
                    {data.rank_placing == "-" ? (
                      <td
                        className={[
                          "center-align",
                          "place_" +
                          data.placing +
                          " lessWidth placings_data center-align",
                        ].join(" ")}
                        nowrap='nowrap'>
                        <span
                          className='textChanges noPadding'
                          dangerouslySetInnerHTML={{
                            __html: data.rank_placing,
                          }}
                        />{" "}
                        {data.placing > 0 &&
                          data.placing != 100000 &&
                          data.rank_placing != "-" ? (
                          null
                        ) : (
                          ""
                        )}
                      </td>
                    )
                    :
                    (props.class_details.is_team_event && data?.is_team_trip) ? 
                          ( 
                              (newTeamRow) &&
                              <td rowSpan={rowSpan} /**  rowSpan = 1 ; for independent trip  */
                               className={[
                                 " lessWidth placings_data center-align",
                                 "verticle-align-center","team-header"
                                 ].join(" ")}>
                                 <span
                                 className={`textChanges place_${data?.team_placing}`}
                                 dangerouslySetInnerHTML={{
                                   __html: data?.team_rank_placing,  //team_rank_placing includes <sup> for styling placing
                                 }}
                                 />
                                 <div>
                                     <img
                                     src={getTeamImagePath(data.team_abbr, data.team_type, false)}
                                     className='team_logo_flag'
                                     alt=''
                                     onerror="this.style.display='none'"
                                     />
                                 </div>
                                  <span className="team_name" style={{ fontWeight: 'bold', textTransform: 'uppercase'}}>{data?.team_name}</span>   
                                  <div className="center-align" style={{ fontWeight: 'bold'}}>
                                    {(data.is_team_trip && data.team_total_score < 200 || props.class_details.class_type != "Jumpers") ? data.team_total_score : '' }
									{ props.class_details.has_r2 ? 
										(data.team_jo_time > 0 && ` / ${data.team_jo_time}`) : 
										(data.team_r1_time > 0 && ` / ${data.team_r1_time}`)
									}
									{
										props.class_details.has_r2 ?
										(data.disqualified_trips_r2.length > 1 && `/ ${data.disqualified_trips_r2[0]}`) :
										(data.disqualified_trips_r1.length > 1 && `/ ${data.disqualified_trips_r1[0]}`)
									}
                                  </div>  
                             </td>
                          )
                    :(
                      <td
                        className={[
                          "center-align",
                          "place_" +
                          data.placing +
                          " lessWidth placings_data center-align",
                        ].join(" ")}
                        nowrap='nowrap'>
                        <span
                          className='textChanges'
                          dangerouslySetInnerHTML={{
                            __html: data.rank_placing,
                          }}
                        />{" "}
                        {data.placing > 0 &&
                          data.placing != 100000 &&
                          data.rank_placing != "-" ? (
                          null
                        ) : (
                          ""
                        )}
                      </td>
                    )}
                    {/* ERROR */}

                    {props.related_data.is_videos_enabled == true && (
                      <td>
                        <a>
                          {props.callby === "division" ? (
                            getVideosListDivision(
                              props.class_details.class_id,
                              data.entryxclasses_uuid
                            ).length > 0 ? (
                              <Popup
                                trigger={
                                  <img
                                    src={video_icon}
                                    className='video-icon'
                                  />
                                }
                                on='hover'
                                position='right center'>
                                <div>
                                  <ul className='popup-ul'>
                                    {getVideosListDivision(
                                      props.class_details.class_id,
                                      data.entryxclasses_uuid
                                    ).map((data, index) => {
                                      return (
                                        <li
                                          key={index}
                                          className='class_list_li'>
                                          <a
                                            onClick={props.playVideo(
                                              data.sgl_id
                                            )}>
                                            {data.class_number} -{" "}
                                            {data.class_name}
                                            {props.getVideoTitle(data)}
                                          </a>
                                        </li>
                                      );
                                    })}
                                  </ul>
                                </div>
                              </Popup>
                            ) : (
                              ""
                            )
                          ) : getVideosList(data.entryxclasses_uuid).length >
                            0 ? (
                            <Popup
                              trigger={
                                <img src={video_icon} className='video-icon' />
                              }
                              on='hover'
                              position='right center'>
                              <div>
                                <ul className='popup-ul'>
                                  {getVideosList(data.entryxclasses_uuid).map(
                                    (data, index) => {
                                      return (
                                        <li
                                          key={index}
                                          className='class_list_li'>
                                          <a
                                            onClick={props.playVideo(
                                              data.sgl_id
                                            )}>
                                            {data.class_number} -{" "}
                                            {data.class_name}
                                            {props.getVideoTitle(data)}
                                          </a>
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            </Popup>
                          ) : (
                            ""
                          )}
                        </a>
                      </td>
                    )}
                    {data.scratch_trip ? (
                      <td>
                        <a>
                          {data.number} - {data.horse}
                        </a>
                      </td>
                    ) : (
                      <td>
                        <Link
                          to={
                            "/entries/detail?eid=" +
                            data.entry_id +
                            "&sid=" +
                            props.current_show
                          }>
                          {data.number} - {data.horse}
                        </Link>
                      </td>
                    )}
                    {data.scratch_trip ? (
                      <td>
                        <a>
                          {!props.class_details.is_team_event &&
                            <img
                              src={
                                props.flag_img_dir[
                                (data.competing_country
                                  ? data.competing_country
                                  : "USA") + ".png"
                                ]
                              }
                              className='rider_flag_inline_image with_wrapping_text'
                            /> }
                          {data.rider_name}
                        </a>
                      </td>
                    ) : (
                      <td>
                        <Link
                          to={
                            "/people/detail?pid=" +
                            data.rider_id +
                            "&sid=" +
                            props.current_show
                          }>
                        {!props.class_details.is_team_event &&
                          <img
                            src={
                              props.flag_img_dir[
                              (data.competing_country
                                ? data.competing_country
                                : "USA") + ".png"
                              ]
                            }
                            className='rider_flag_inline_image with_wrapping_text'
                          /> }
                          {data.rider_name}
                        </Link>
                      </td>
                    )}
                    { (props.related_data.has_prize_money && !props.class_details.is_team_event )  && (
                      <td style={{width: "9%"}}>
                        <a>
                          {data.total_prize_money == 0
                            ? "-"
                            : props.format_currancy(data.total_prize_money)}
                        </a>
                      </td>
                    )}
                    {
                      (props.class_details.class_type == "Jumpers" ) &&
                      <>
                      
                          <td>
                            <a id={data?.is_drop_trip_r1 ? "drop_trip":""} >{getFaultTime(data.time_fault_one, data.faults_one, data.time_one, 1, data.team_placing, true, false, true)}</a>
                          </td>
                          <td>
                            <a id={data?.is_drop_trip_r1 ? "drop_trip":""} >{getFaultTime(data.time_fault_one, data.faults_one, data.time_one, 1, data.team_placing, true, true)}</a>
                          </td>
                          <td style={{width: "8%"}}  nowrap="nowrap">
                            <a  id={data?.is_drop_trip_r1 ? "drop_trip":""} >
                              {data.disqualify_status_one != ""
                                ? data.disqualify_status_one
                                : getFaultTime(
                                  data.time_fault_one,
                                  data.faults_one,
                                  data.time_one,
                                  1,
                                  data.team_placing,
                                  true
                                )}
                            </a>
                          </td>
                          {
                            props.class_details.is_team_event && (newTeamRow || !data?.is_team_trip)
                              && 
                              <td rowSpan={!data?.is_team_trip ? 1 : rowSpan}  className="center-align verticle-align-center placings_data r1_total">
                                  {(data?.is_team_trip && data?.team_score_one < 200) ? data?.team_score_one : '' }
                              </td>
                            
                          }
                      </>
                    }
                    { (props.class_details.class_type == "Jumpers"  && (props.class_details.has_r2 || props.jumper_table_info.hasJO) ) && (
                      <>
                        <td>
                          <a id={data?.is_drop_trip_r2 ? "drop_trip":""} >{getFaultTime(data.time_fault_two, data.faults_two, data.time_two, 2, data.team_placing, true, false, true)}</a>
                        </td>
                        <td>
                          <a id={data?.is_drop_trip_r2 ? "drop_trip":""} >{getFaultTime(data.time_fault_two, data.faults_two, data.time_two, 2, data.team_placing, true, true)}</a>
                        </td>
                        <td style={{width: "8%"}} nowrap="nowrap">
                          <a id={data?.is_drop_trip_r2 ? "drop_trip":""} >
                            {data.disqualify_status_two != ""
                              ? data.disqualify_status_two
                              : getFaultTime(
                                data.time_fault_two,
                                data.faults_two,
                                data.time_two,
                                2,
                                data.team_placing,
                                true
                              )}
                          </a>
                        </td>
                        { 
                          props.class_details.is_team_event && (newTeamRow || !data?.is_team_trip ) && (props.class_details.has_r2 || props.jumper_table_info.hasJO)
                           &&
                          <td rowSpan={!data?.is_team_trip ? 1 : rowSpan}  className="center-align verticle-align-center placings_data r2_total"  >
                           {(data?.is_team_trip && props.class_details.has_r2 && data?.has_r2 && data?.team_score_two < 200) ? data?.team_score_two : '' }
                          </td>
                        }

                        { 
                            props.jumper_table_info.hasR3Data &&
                            <> 
                                <td>
                                    <a>{getFaultTime(data.time_fault_three, data.faults_three, data.time_three, 2, data.team_placing, true, false, true)}</a>
                                </td>
                                <td>
                                    <a>{getFaultTime(data.time_fault_three, data.faults_three, data.time_three, 2, data.team_placing, true, true)}</a>
                                </td>
                                <td style={{width: "8%"}} nowrap="nowrap">
                                    <a>
                                        {data.disqualify_status_three ? data.disqualify_status_three
                                        : getFaultTime(
                                            data.time_fault_three,
                                            data.faults_three,
                                            data.time_three,
                                            2,
                                            data.team_placing,
                                            true
                                        )}
                                    </a>
                                </td>
                                {
                                    props.class_details.is_team_event && (newTeamRow || !data?.is_team_trip) &&
                                    <td rowSpan={!data?.is_team_trip ? 1 : rowSpan}  className="center-align verticle-align-center placings_data r2_total"  >
                                    {(data?.is_team_trip && data?.has_r3 && data?.team_score_three < 200) ? data?.team_score_three : '' }
                                    </td>
                                }
                            </>
                        }
                      </>
                     
                    )}
                    { (props.class_details.class_type != "Jumpers" ) &&
                      props.related_data.score_fields.map((f, index) => {
                        if (data.disqualify_status_one && f == "1") {
                          return (
                            <td className='center-align'>
                              <a>{data.disqualify_status_one}</a>
                            </td>
                          );
                        } else if (data.disqualify_status_two && f == "2" && props.related_data.hunter_type.indexOf("Hunter Derby") >= 0) {
                          return (
                            <td className='center-align'>
                              <a>{data.disqualify_status_two}</a>
                            </td>
                          );
                        } else {
                          return (
                            <td className='center-align'>
                              <a>{data["score" + f]}</a>
                            </td>
                          );
                        }
                    })}
                    { (props.class_details.class_type != "Jumpers" ) && (
                      <td className='center-align'>
                        {(data.disqualify_status_one) ?
                          <a id={data?.is_drop_trip_r1 ? "drop_trip":""}>{data.disqualify_status_one}</a>
                          :
                          <a id={data?.is_drop_trip_r1 ? "drop_trip":""}>{data.score}</a>
                        }
                      </td>
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
      <div>
        {props.playing_video && (
          <VideoPlayer
            is_open_play_video_modal={props.is_open_play_video_modal}
            is_open_do_subscription_modal={props.is_open_do_subscription_modal}
            is_download_subscription={false}
            video_to_play={props.video_to_play}
            is_admin={props.is_admin}
            closeModal={props.closeModal}
            closeSubscriptionModal={props.closeSubscriptionModal}
            playing_preview={false}
            play_video_path={props.video_to_play.video_url}
            playVideoAfterSubscribe={props.playVideoAfterSubscribe}
            VideoSubscriptionElement={props.VideoSubscriptionElement}
            ref={props.VideoPlayerElement}
          />
        )}
      </div>
    </div>
  );
}
